// 출퇴근 엑셀 다운로드 헬퍼 (Phase 1-2 후속)
// 4곳(파인/DOT/LNJ/통합) 모두에서 공유. 라우트는 attendancePath/companyCode/selectedCompanyCodes로 자동 분기.
// apiClient는 JSON 전제이므로 fetch 직접 사용 (출퇴근 달력 엑셀 다운로드와 동일 패턴).

/**
 * 현재 필터 상태 그대로 엑셀 다운로드 트리거
 * @param {object} ctx
 *   attendancePath, companyCode, selectedCompanyCodes, year, month, ipFilter, selectedIpOption, showToast
 */
export async function triggerAttendanceExcelDownload(ctx) {
  const {
    attendancePath, companyCode, selectedCompanyCodes,
    year, month, ipFilter, selectedIpOption, nameQuery, showToast,
  } = ctx;
  try {
    // URL 구성 — 모드별 분기
    const isIntegrated = /\/integrated-menus\/\d+\/attendance$/.test(attendancePath);
    // ext(외부회사) export 는 화면 경로가 실제 ext 라우트일 때만. 회사코드로 판별하면 테넌트 메인회사(자기회사)도
    //   ext 로 잘못 가 403/404(EXTERNAL_* 권한·external_companies 미보유). 출퇴근 시간설정 모달과 동일하게 '경로' 기준 분기.
    const isExtPath = /^\/api\/admin\/ext\/[^/]+\/attendance$/.test(attendancePath);
    const params = new URLSearchParams();
    params.set('year', String(year));
    params.set('month', String(month));
    // 직원 이름 — 시나리오 A (시프티 매트릭스) 분기. 시트 동기화와 동일 의미.
    const trimmedName = String(nameQuery || '').trim();
    if (trimmedName) params.set('name', trimmedName);
    if (ipFilter) params.set('ip_address', ipFilter);
    if (selectedIpOption?.alias) params.set('ip_alias', selectedIpOption.alias);

    let url;
    if (isIntegrated) {
      // 통합: 회사 칩 선택 codes 반영 (없으면 메뉴 전체)
      if (Array.isArray(selectedCompanyCodes) && selectedCompanyCodes.length > 0) {
        params.set('codes', selectedCompanyCodes.join(','));
      }
      url = `${attendancePath}/export?${params.toString()}`;
    } else if (isExtPath && companyCode) { // 본사 코드는 회사 주소에서 본사 주소로 돌려보내져 여기 안 온다(옛 'PINE' 비교 삭제 2026-10-30)
      url = `/api/admin/ext/${companyCode}/attendance/export?${params.toString()}`;
    } else {
      url = `/api/admin/attendance/export?${params.toString()}`;
    }

    // 토큰: apiClient.getToken()과 동일 키 사용 (impersonation 미고려 — 관리자 전용 다운로드)
    const token = localStorage.getItem('accessToken') || '';
    const resp = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
    if (!resp.ok) {
      const text = await resp.text().catch(() => '');
      showToast(`다운로드 실패 (${resp.status}) ${text.slice(0, 80)}`, 'error');
      return;
    }
    // 파일명 추출: Content-Disposition filename*=UTF-8''<encoded>
    const cd = resp.headers.get('Content-Disposition') || '';
    const m = cd.match(/filename\*=UTF-8''([^;]+)/i);
    const filename = m ? decodeURIComponent(m[1]) : `attendance_${year}_${month}.xlsx`;

    // Blob → 가상 <a> 클릭으로 다운로드
    const blob = await resp.blob();
    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl; a.download = filename;
    document.body.appendChild(a); a.click();
    a.remove(); URL.revokeObjectURL(blobUrl);
    showToast(`다운로드 완료: ${filename}`, 'success');
  } catch (e) {
    showToast(`다운로드 오류: ${e.message}`, 'error');
  }
}
